import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[bnAccountNumberMask]',
})
export class BnAccountNumberMaskDirective implements OnInit {
  value = '';

  constructor(private ngControl: NgControl) {}

  ngOnInit(): void {
    if (this.ngControl?.valueAccessor) {
      this.ngControl.valueAccessor.registerOnChange = (value: string) => {
        this.value = value;
      };
    }
  }

  @HostListener('ngModelChange', ['$event'])
  ngModelChange(value: any) {
    if (this.ngControl.valueAccessor) {
      const maskedValue = this.applyMask(value);
      this.ngControl.valueAccessor.writeValue(maskedValue);
    }
  }

  applyMask(val: string): string {
    const arr = val.replace(/ /g, '').match(/.{1,4}/g);
    return arr?.join(' ') || '';
  }
}
